// extracted by mini-css-extract-plugin
export default {"outerWrap":"outerWrap--DYe3x","header":"header--CiWWX","titleContainer":"titleContainer--RUXzk","scrollContainer":"scrollContainer--kOKsZ"};